module.exports = __webpack_public_path__ + "img/reputation-revenue-calculator.49d82965.png";